export const INVOZIO_BLOB_BASE =
  import.meta.env.VITE_BLOB_CONTAINER ?? 'https://invozioprod.blob.core.windows.net/files';